import React, { useState, useCallback } from 'react';
import { usePopper } from 'react-popper';
import ReactDOM from 'react-dom';
import { theme } from '../../theme';
import { Sides } from './types';
import { Container, TooltipText, Tip, Hoverable, Wrap, Triangle } from './styled';
const defaultConfig = {
    duration: 400,
    side: Sides.TOP,
    triangleOffset: 8,
    tipMinWidth: 60,
    tipMaxWidth: 340,
};
export const Tooltip = ({ children, text, content, config, reversed = false, className, withTriangle, initialShouldShow = false, useReactPortal = true, }) => {
    const hasText = text ? text.trim().length > 0 : false;
    const usedConfig = Object.assign(Object.assign({}, defaultConfig), config);
    const { duration, side, triangleOffset, tipMinWidth, tipMaxWidth } = usedConfig;
    const classNames = {
        container: className && `${className} ${className}-container`,
        tip: className && `${className}-tip`,
        wrap: className && `${className}-wrap`,
        triangle: className && `${className}-triangle`,
        hoverable: className && `${className}-hoverable`,
    };
    const [shouldShow, setShouldShow] = useState(initialShouldShow);
    const [hoverableElement, setHoverableElement] = useState(null);
    const [popperElement, setPopperElement] = useState(null);
    const { styles, attributes } = usePopper(hoverableElement, popperElement, {
        placement: `${side}-${reversed ? 'end' : 'start'}`,
        modifiers: [
            {
                name: 'offset',
                options: {
                    offset: [0, 10],
                },
            },
        ],
    });
    const show = useCallback(() => setShouldShow(true), [setShouldShow]);
    const hide = useCallback(() => setShouldShow(false), [setShouldShow]);
    const tooltipStyles = Object.assign(Object.assign({}, styles.popper), { zIndex: theme.layers.tooltip });
    const tooltipMarkup = shouldShow && (content || hasText) && (React.createElement(Tip, Object.assign({ className: classNames.tip, ref: setPopperElement, duration: duration, triangleOffsetSize: triangleOffset, style: tooltipStyles }, attributes.popper, { role: "tooltip" }),
        React.createElement(Wrap, { className: classNames.wrap, tipMinWidth: tipMinWidth, tipMaxWidth: tipMaxWidth }, content !== null && content !== void 0 ? content : React.createElement(TooltipText, null, text)),
        withTriangle && React.createElement(Triangle, { id: "veeqo-components-triangle", className: classNames.triangle })));
    return (React.createElement(Container, { className: classNames.container },
        useReactPortal ? ReactDOM.createPortal(tooltipMarkup, document.body) : tooltipMarkup,
        React.createElement(Hoverable, { ref: setHoverableElement, className: classNames.hoverable, onMouseEnter: show, onMouseLeave: hide }, children)));
};
//# sourceMappingURL=Tooltip.js.map